import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-up.png'

const ArrowUpIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} />
}

export default ArrowUpIcon
